<template>
  <div class="about-overlay" v-if="visible">
    <div class="about-container">
      <button class="about-close" @click="closeAboutPage">×</button>
      <div class="about-left">
        <div class="about-logo">
      <img src="/playground_assets/danseuse.png" alt="Nuance Logo" />
    </div>
      </div>
      <div class="about-right">
        <div class="about-title">about nuance radio</div>
     <div class="about-text">
      A nuance exists in the subtle in-between, where differences softly converge. A sequence of neighboring intervals, whether in color or sound.<br /><br />
      Nuance gently brings together contrasts, harmonizing where others divide. In a world increasingly fragmented, we strive to unite, more than ever.<br /><br />
      <span style="font-weight: 500">Nuance Radio is our ever-flowing sound library, available 24/7 on this website.</span><br /><br />
    </div>
        <div class="about-support-buttons">
          <a href="https://patreon.com/NuanceRadio" target="_blank" rel="noopener" class="about-support-btn patreon">Support on Patreon</a>
          <a href="https://www.paypal.com/donate/?hosted_button_id=SXGA8V28PV4LL" target="_blank" rel="noopener" class="about-support-btn paypal">Donate via Paypal</a>
    </div>
        <div class="about-socials-container">
      <socials></socials>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Socials from './socials.vue'

export default {
  components: { Socials },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeAboutPage() {
      this.$emit('close');
    },
    supportPatreon() {
      window.open('https://patreon.com/NuanceRadio', '_blank');
    },
    donatePaypal() {
      window.open('https://www.paypal.com/donate/?hosted_button_id=SXGA8V28PV4LL', '_blank');
    },
  },
  mounted() {
    document.body.onclick = null;
  }
}
</script>

<style scoped>
.about-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 20000;
  background: rgba(255,255,255,0.95);
  /* Remove or reduce blur for profile-like transparency */
  /* backdrop-filter: blur(8px); */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: auto;
}
.about-container {
  display: flex;
  flex-direction: row;
  background: #fff;
  border-radius: 0;
  box-shadow: 0 2px 24px rgba(0,0,0,0.12);
  padding: 0;
  width: 80vw;
  max-width: 900px;
  min-width: 320px;
  height: auto;
  min-height: 400px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  transition: width 0.2s, height 0.2s;
}
.about-left {
  background: #f5f5f5;
  width: 28%;
  min-width: 140px;
  max-width: 220px;
  flex-basis: 28%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  transition: width 0.2s;
}
.about-logo {
  width: 70%;
  margin: 2.5rem auto 2.5rem auto;
}
.about-logo img {
  width: 100%;
  object-fit: contain;
}
.about-right {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  padding: 2.5vw 2vw 2vw 2vw;
  min-width: 0;
  min-height: 0;
  max-height: 80vh;
  overflow: hidden;
  transition: padding 0.2s;
  align-items: center;
  justify-content: center;
}
.about-title {
  font-family: Syne, sans-serif;
  font-weight: 600;
  font-size: clamp(1.1rem, 2vw, 1.6rem);
  margin-bottom: 1.2rem;
  color: #222;
  text-align: center;
}
.about-text {
  color: #222;
  font-family: Syne, sans-serif;
    font-weight: 400;
  font-size: clamp(1rem, 1.2vw, 1.1rem);
    text-align: center;
    background-color: white;
    padding: 10px;
  margin: 20px 0 20px 0;
}
.about-support-buttons {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}
.about-support-btn {
  font-family: Syne, sans-serif;
  font-size: clamp(1rem, 1.2vw, 1.08rem);
  font-weight: 600;
  padding: 0.7rem 1.4rem;
  border-radius: 0;
  border: none;
  text-decoration: none;
  color: #fff;
  background: #222;
  transition: background 0.2s, color 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 0.5rem;
  text-align: center;
  display: inline-block;
  white-space: nowrap;
}
.about-support-btn.patreon {
  background: #424242;
}
.about-support-btn.paypal {
  background: #0070ba;
}
.about-support-btn:hover {
  filter: brightness(1.1);
  color: #fff;
}
.about-socials-container {
  margin-top: 20px;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: center;
}
.about-close {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  background: transparent;
  border: 2px solid #222;
  border-radius: 50%;
  width: 2.2rem;
  height: 2.2rem;
  font-size: 1.4rem;
  color: #222;
  cursor: pointer;
  z-index: 2;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991px) {
  .about-overlay {
    align-items: flex-start;
    justify-content: center;
  }
  .about-container {
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    width: 98vw;
    height: auto;
    max-height: 100vh;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    border-radius: 0;
    overflow: auto;
    transition: width 0.2s, height 0.2s;
  }
  .about-left {
    width: 100%;
    min-width: 0;
    max-width: 100vw;
    border-radius: 0;
    min-height: unset;
    padding: 2rem 0 1rem 0;
    box-sizing: border-box;
    flex-basis: auto;
  }
  .about-logo {
    width: 30vw;
    min-width: 80px;
    max-width: 180px;
    margin: 2rem auto 1.2rem auto;
  }
  .about-right {
    padding: 1.5rem 1rem 1.5rem 1rem;
    max-height: none;
    min-height: 0;
    overflow-y: auto;
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    transition: padding 0.2s;
    align-items: center;
    justify-content: center;
  }
  .about-title {
    font-size: clamp(1.1rem, 2vw, 1.3rem);
  }
  .about-text {
    font-size: clamp(1rem, 2vw, 1.05rem);
    margin: 10px 0 10px 0;
  }
  .about-support-buttons {
    flex-direction: row;
    gap: 0.7rem;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .about-support-btn {
    font-size: clamp(1rem, 2vw, 1.08rem);
    width: auto;
    padding: 0.7rem 1.2rem;
  }
  .about-close {
    top: 1.2rem;
    right: 1.2rem;
    width: 2.2rem;
    height: 2.2rem;
    font-size: 1.4rem;
  }
}
@media (max-width: 600px) {
  .about-container {
    min-width: 0;
    min-height: unset;
    width: 100vw;
    height: auto;
    border-radius: 0;
    overflow: auto;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
  }
  .about-logo {
    width: 40vw;
    min-width: 60px;
    max-width: 120px;
    margin: 0.5rem auto 0.1rem auto;
  }
  .about-right {
    padding: 2.5rem 0.5rem 2.5rem 0.5rem;
    max-height: none;
    min-height: 0;
    overflow-y: auto;
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    transition: padding 0.2s;
    align-items: center;
    justify-content: flex-start;
  }
  .about-title {
    font-size: clamp(1.1rem, 2vw, 1.2rem);
    margin-top: 0.2rem;
    margin-bottom: 0.7rem;
  }
  .about-text {
    font-size: clamp(1rem, 2vw, 1.02rem);
    margin: 6px 0 6px 0;
  }
  .about-support-btn {
    font-size: clamp(1rem, 2vw, 1.05rem);
    width: auto;
    padding: 0.6rem 0.7rem;
    border-radius: 0;
  }
}
</style>

